var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { PeekInputSelect } from "@piiqtechnologies/ui-components";
import { getAccessDevicesManufacturers } from "@utils/accessDeviceHelper";
const ManufacturerSelector = (_a) => {
    var { field } = _a, props = __rest(_a, ["field"]);
    const manufacturers = useMemo(() => getAccessDevicesManufacturers(), []);
    return (React.createElement(PeekInputSelect, Object.assign({ labelProps: {
            sx: {
                mb: 0.6,
                fontWeight: "normal",
            },
        } }, props, { field: field, items: manufacturers })));
};
export default ManufacturerSelector;
